/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PatchedServiceLocationSeoFieldsRequest
 */
export interface PatchedServiceLocationSeoFieldsRequest {
  /**
   *
   * @type {string}
   * @memberof PatchedServiceLocationSeoFieldsRequest
   */
  locationSlug?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedServiceLocationSeoFieldsRequest
   */
  header?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedServiceLocationSeoFieldsRequest
   */
  titleTag?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedServiceLocationSeoFieldsRequest
   */
  descriptionTag?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedServiceLocationSeoFieldsRequest
   */
  description?: string | null
  /**
   *
   * @type {boolean}
   * @memberof PatchedServiceLocationSeoFieldsRequest
   */
  useLocalMeta?: boolean
  /**
   *
   * @type {boolean}
   * @memberof PatchedServiceLocationSeoFieldsRequest
   */
  useLocalDescription?: boolean
  /**
   *
   * @type {number}
   * @memberof PatchedServiceLocationSeoFieldsRequest
   */
  serviceId?: number
  /**
   *
   * @type {number}
   * @memberof PatchedServiceLocationSeoFieldsRequest
   */
  locationId?: number
}

/**
 * Check if a given object implements the PatchedServiceLocationSeoFieldsRequest interface.
 */
export function instanceOfPatchedServiceLocationSeoFieldsRequest(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function PatchedServiceLocationSeoFieldsRequestFromJSON(
  json: any,
): PatchedServiceLocationSeoFieldsRequest {
  return PatchedServiceLocationSeoFieldsRequestFromJSONTyped(json, false)
}

export function PatchedServiceLocationSeoFieldsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedServiceLocationSeoFieldsRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    locationSlug: !exists(json, 'locationSlug') ? undefined : json['locationSlug'],
    header: !exists(json, 'header') ? undefined : json['header'],
    titleTag: !exists(json, 'titleTag') ? undefined : json['titleTag'],
    descriptionTag: !exists(json, 'descriptionTag') ? undefined : json['descriptionTag'],
    description: !exists(json, 'description') ? undefined : json['description'],
    useLocalMeta: !exists(json, 'useLocalMeta') ? undefined : json['useLocalMeta'],
    useLocalDescription: !exists(json, 'useLocalDescription')
      ? undefined
      : json['useLocalDescription'],
    serviceId: !exists(json, 'serviceId') ? undefined : json['serviceId'],
    locationId: !exists(json, 'locationId') ? undefined : json['locationId'],
  }
}

export function PatchedServiceLocationSeoFieldsRequestToJSON(
  value?: PatchedServiceLocationSeoFieldsRequest | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    locationSlug: value.locationSlug,
    header: value.header,
    titleTag: value.titleTag,
    descriptionTag: value.descriptionTag,
    description: value.description,
    useLocalMeta: value.useLocalMeta,
    useLocalDescription: value.useLocalDescription,
    serviceId: value.serviceId,
    locationId: value.locationId,
  }
}
